var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"view-tabs"},_vm._l((_vm.views),function(view){return _c('div',{key:view.value,staticClass:"view",class:{ 'view-active': _vm.value === view.value },on:{"click":function($event){return _vm.$emit('change', view.value)}}},[_c('span',{staticClass:"mck3"},[_vm._v(_vm._s(view.icon))]),_c('p',[_vm._v(_vm._s(view.name))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }